export default "__VITE_ASSET__T6BQ97yh__"